import { useState } from 'react';
import { reportService } from '@services';
import { NL2SQLConfig, NL2SQLMetadata, NL2SQLChartType } from '@app-types';

export const useNaturalLanguageWidget = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  // Security: SQL is never exposed to frontend - only query_id is used
  const createWidgetFromNaturalLanguage = async (
    nlQuery: string,
    onSuccess: (widgetData: {
      name: string;
      query_id: string;
      visualization_type: NL2SQLChartType;
      config?: NL2SQLConfig;
      metadata?: NL2SQLMetadata;
    }) => void | Promise<void>
  ) => {
    if (!nlQuery.trim()) {
      throw new Error('Query cannot be empty');
    }

    setIsGenerating(true);
    try {
      console.log('🚀 Generating widget for query:', nlQuery);
      const result = await reportService.translateNaturalLanguageToSQL(nlQuery);

      console.log('🔍 Full translate response:', result);
      console.log('🔍 Query ID:', result.query_id);
      console.log('🔍 ChartType from response:', result.chartType);

      const widgetData = {
        name: result.config?.title || result.visualization.title,
        query_id: result.query_id,
        visualization_type: result.chartType || result.visualization.chartType,
        config: result.config,
        metadata: result.metadata
      };

      console.log('📝 Creating widget (SQL secured on server):', {
        name: widgetData.name,
        query_id: widgetData.query_id,
        visualization_type: widgetData.visualization_type,
        hasConfig: !!widgetData.config,
        hasMetadata: !!widgetData.metadata
      });

      await onSuccess(widgetData);
      return result;
    } catch (error) {
      console.error('Error creating widget:', error);
      throw new Error('Failed to create widget. Please try a different query.');
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    createWidgetFromNaturalLanguage,
    isGenerating
  };
};
